export enum FormType {
    Profile = 'profile',
    Address = 'address',
    Ielts = 'ielts'
}

export enum SectionType {
    Profile = 'profileDetail',
    Address = 'addressDetail',
    Ielts = 'ieltsDetail'
}

export enum FormValues {
    UNKNOWN_COUNTRY = '29e7b37e-08ac-3b29-7477-fb12552762a9'
}

export enum DetailFormStatus {
    INCOMPLETE = 'Incomplete',
    COMPLETED = 'Completed'
}

export enum LocalStorageKeys {
isOnline = 'isOnline'
}

export enum PaymentStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    UNPAID = 'UNPAID'
}

export enum nbaActions {
    RESULTS_PENDING = 'Your results are pending',
    BOOKING_CONFIRMED = 'Booking confirmed, prepare now!',
    COMPLETE_BIOMETRIC_CONSENT = 'Complete biometric consent'
}